import React from "react";
import { useState } from "react";
import imageUrl from "utils/imageUrl";

function UploadKyc({ onButtonClick }) {
  const [kyc, setKyc] = useState(false);
  const [file, setFile] = useState(null);
  console.log(file);
  const handleChange = (event) => {
    setFile(URL.createObjectURL(event.target.files[0]));
  };
  return (
    <>
      {" "}
      <h5 className="mt-5">KYC Submission</h5>
      <form action="#" name="save__from" method="post" className="save__form">
        <div className="row">
          <div className="col-sm-6">
            <div className="idcard h-100 d-flex flex-column justify-content-center">
              <p>Identity Card (Front) </p>
              <div className="inner-id-card d-flex mt-3 mb-5">
                <div className="upload d-flex flex-column align-items-center">
                  <label
                    htmlFor="nic-front"
                    className="d-flex flex-column align-items-center"
                  >
                    {" "}
                    <i className="fa-solid fa-upload"></i> <span>Upload</span>
                  </label>
                  <input
                    type="file"
                    name="doc"
                    id="nic-front"
                    className="d-none"
                    onChange={handleChange}
                  />
                </div>
                <div className="delete mx-5 d-flex flex-column align-items-center">
                  <i className="fa-solid fa-trash"></i> <span>Delete</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="id-img ">
              {/* <img src={imageUrl("id-front.jpg")} width={"100%"} alt="" /> */}
              <img className="place"
                src={file === null ? imageUrl("placeholder.png") : file}
                // style={{ width: "40%"}}
                alt="Upload your Nic"
              />
              {/* <Document file={file} /> */}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="input input--secondary">
              <label for="name">Name (IC)</label>
              <input
                type="text"
                name="Name"
                id="name"
                placeholder="Name"
                required="required"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="input input--secondary">
              <label for="icnumber">IC Number</label>
              <input
                type="text"
                name="icnumber"
                id="icnumber"
                placeholder="770707-07-0707"
                required="required"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="input input--secondary">
              <label for="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Email"
                required="required"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="input input--secondary">
              <label for="mobile"> Mobile : </label>
              <input
                type="text"
                name="mobile"
                id="mobile"
                placeholder="+62 948 9304 939"
                required="required"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="regi__type mt-0">
              <label for="methodSelect">Gender : </label>
              <select
                className="type__select"
                // value={gender}
                // onChange={(e) => setGender(e.target.value)}
                id="methodSelect"
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="others">Other</option>
              </select>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="input input--secondary d-flex align-items-center">
              <label for="age" style={{ width: "20%" }}>
                Age :{" "}
              </label>
              <input
                type="number"
                name="age"
                id="age"
                placeholder="18"
                required="required"
                min={18}
              />
            </div>
          </div>
        </div>
        <div>
          <button
            type="submit"
            className="button button--effect"
            onClick={() => onButtonClick("pagetwo")}
          >
            Next
          </button>
        </div>
      </form>
    </>
  );
}

export default UploadKyc;
